import {Resolve} from "@angular/router";
import {Injectable} from "@angular/core";
import {LocationService} from "../../../services/locationService";
import {SearchResponse} from "../../../objects/responses/searchResponse";
/**
 * Created by alex.y on 7/31/2017.
 */

@Injectable()
export class LocationManagementResolver implements Resolve<SearchResponse<Location>> {

    constructor(private locationService: LocationService) {
    }

    public resolve(): Promise<SearchResponse<Location>> {

        return this.locationService.getAll(12, 0).then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/locationManagement/locationManagment.resolver.ts